<template>
  <div class="picker content-width">
    <button class="option" @click="selected('experience')">
      <span>Experience</span>
    </button>
    <button class="option" @click="selected('projects')">
      <span>Projects</span>
    </button>
    <!-- <button class="option" @click="selected('services')">
      <span>Services</span>
    </button> -->
    <button class="option" @click="selected('skills')">
      <span>Skills</span>
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    selected (destination) {
      this.$router.push(destination);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/colors.scss';
@import '~@/styles/sizes.scss';

.picker {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.option {
  display: block;
  position: relative;
  width: 100%;
  max-width: 280px;
  height: 80px;
  margin: 8px 0;
  padding: 0;
  background: rgba($color-fg, 0.2);
  transform: scale(0.98);
  border: none;
  border-radius: 16px;
  transition: all 1s;

  &:hover {
    transform: scale(1);
    border-radius: 12px;
  }

  span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 22px;
  }
}
</style>
